module.exports = __webpack_public_path__ + "static/media/56119817_2519305981477911_7562702118444859392_o.48b400f4.jpg";